import { createStore } from '@cobuildlab/react-simple-state';

export const changeEmailDialogStore = createStore<{
  open: boolean;
}>({
  initialValue: {
    open: false,
  },
});
